import styled, { css } from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCollaboratorEvaluation = styled.div<{ $dimmed?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 310px;
  border-right: 1px solid ${theme.colors.purple_2};
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: ${({ $dimmed }) => ($dimmed ? 1 : 0)};
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 1;
  }
`;

export const StyledSectionsLeftPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 10px;
  min-height: 48px;
  max-height: 240px;
`;

export const StyledSectionsLeftPanelContainerPractice = styled(
  StyledSectionsLeftPanelContainer,
)<{ $isOptionCollaborators: boolean; $dimmed: boolean }>`
  min-height: ${(props) => (props.$isOptionCollaborators ? "106px" : "48px")};
  border-top: ${({ $dimmed }) =>
    $dimmed ? `1px solid ${theme.colors.purple_2}` : "none"};
`;

export const StyledSectionsLeftPanelContainerSpeaker = styled(
  StyledSectionsLeftPanelContainer,
)`
  max-height: 240px;
`;

export const StyledTitlesLeftPanel = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const StyledInfoCollaboratorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
`;

export const StyledCmCollaboratorContainer = styled(
  StyledInfoCollaboratorContainer,
)<{
  $isSelectedCareerManager: boolean;
}>`
  border: ${({ $isSelectedCareerManager }) =>
    $isSelectedCareerManager ? `1px solid ${theme.colors.black}` : "0px solid"};
  padding: 8px;

  &:hover {
    background-color: ${({ $isSelectedCareerManager }) =>
      $isSelectedCareerManager ? "" : theme.colors.purple_2};
  }
`;

export const StyledSingleCollaboratorContainer = styled(
  StyledInfoCollaboratorContainer,
)<{
  $isSelectedCollaborator?: boolean;
}>`
  background-color: ${({ $isSelectedCollaborator }) =>
    $isSelectedCollaborator ? theme.colors.purple_2 : ""};
  justify-content: space-between;
  padding: 8px;

  &:hover {
    background-color: ${theme.colors.purple_2};
  }
`;

export const StyledAccordionWrapper = styled(StyledInfoCollaboratorContainer)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  & > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const StyledCollaboratorContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 10px;
  min-height: 0;
`;

export const StyledAccordionContent = styled.div`
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  height: calc(100% - 32px);
  min-height: 0;
`;

export const StyledSelectAccordion = styled.div`
  margin: 10px 0;
`;

export const StyledCollaboratorSelectContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StyledCMFollowListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const StyledEvaluationLeftPanelContainer = styled.div<{
  $isEvaluationOpen: boolean;
  $isExaminedOpen: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;

  & > ${StyledAccordionWrapper}:first-child {
    flex-grow: ${({ $isEvaluationOpen }) => ($isEvaluationOpen ? 1 : 0)};
    flex-shrink: 0;
    min-height: 48px;
    padding: 0 20px;
  }

  & > ${StyledAccordionWrapper}:last-child {
    flex-grow: ${({ $isExaminedOpen }) => ($isExaminedOpen ? 1 : 0)};
    flex-shrink: 0;
    min-height: 48px;
  }
`;

export const StyledTitleInternalGrade = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
`;

export const StyledExaminedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  &:not(:first) {
    margin-top: 35px;
  }
`;

export const StyledCollaboratorExaminedContainer = styled(
  StyledCollaboratorSelectContainer,
)`
  gap: 35px;
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  border-bottom: 1px solid ${theme.colors.purple_2};
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  box-sizing: border-box;
`;

export const StyledCollaboratorToView = styled.div`
  border: 1px solid ${theme.colors.purple_2};
  border-radius: ${theme.variables.border_radius_1};
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
  max-width: 380px;
  justify-content: space-between;
`;

export const StyledModalBody = styled.div`
  display: flex;
  height: 100%;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledCollaboratorDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const StyledCollaboratorInformations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledEvaluationContainer = styled.div<{
  $isExaminedOpen: boolean;
}>`
  overflow: auto;
  height: ${({ $isExaminedOpen }) =>
    $isExaminedOpen ? "calc(100vh - 615px)" : "calc(100vh - 365px)"};
`;

export const StyledCollaboratorExaminatedDivider = styled.div<{
  $isExaminedOpen: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px;

  ${({ $isExaminedOpen }) =>
    $isExaminedOpen
      ? css`
          flex: 1;
          min-height: 0;
          overflow: auto;
        `
      : css`
          flex: 0;
          min-height: auto;
          overflow: initial;
        `}
`;

export const StyledHeaderLeftPanel = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: -20px;
`;
